<template>
    <nav id="navbar-main" class="navbar is-fixed-top">
        <div class="navbar-brand">
            <div class="navbar-item">
                <div class="control pl3">
                    <router-link to="/" tag="span">
                        {{
                            $Amplify.I18n.get('chirashi-vision.com') +
                                ' ' +
                                $Amplify.I18n.get('Management') +
                                ' ' +
                                $Amplify.I18n.get('Page')
                        }}
                    </router-link>
                </div>
            </div>
        </div>
        <div class="navbar-brand is-right" v-if="$store.state.user">
            <a
                class="navbar-item navbar-item-menu-toggle is-hidden-desktop"
                @click.prevent="menuNavBarToggle"
            >
                <b-icon :icon="menuNavBarToggleIcon" custom-size="default" />
            </a>
        </div>
        <div
            class="navbar-menu fadeIn animated faster"
            :class="{ 'is-active': isMenuNavBarActive }"
            v-if="$store.state.user"
        >
            <div class="navbar-end">
                <nav-bar-menu class="has-divider">
                    <b-icon icon="face" custom-size="default" />
                    <span> {{ $store.state.user.username }} </span>
                </nav-bar-menu>
                <a class="navbar-item is-desktop-icon-only">
                    <sign-out v-if="$store.state.user" />
                </a>
            </div>
        </div>
    </nav>
</template>

<script>
import NavBarMenu from '@/components/NavBarMenu'
import SignOut from '@/components/SignOut'

export default {
    components: {
        NavBarMenu,
        SignOut
    },
    data() {
        return {
            isMenuNavBarActive: false,
            isAsideMobileExpanded: false,
            isLoggedIn: true,
            signOutConfig: {
                signOutButton: 'ログアウト'
            }
        }
    },
    computed: {
        menuNavBarToggleIcon() {
            return this.isMenuNavBarActive ? 'close' : 'dots-vertical'
        }
    },
    methods: {
        menuNavBarToggle() {
            this.isMenuNavBarActive = !this.isMenuNavBarActive
        }
    }
}
</script>

<style scoped>
.pl3 {
    padding-left: 1rem;
}
</style>
